// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"insuraExplanModal_modalTitle__r5_Am","explanWrap":"insuraExplanModal_explanWrap__HXUJm","title":"insuraExplanModal_title__3cZHV"};